import React, { Component } from 'react';
import classNames from 'classnames';
import { getModalActionButton } from '../utils';
import DefaultSkyLightStateless from '../../shared/components/DefaultSkyLightStateless';

interface Props {
  closeModal: any,
  isVisible: boolean,
  title: string,
  buttonType: string,
  modalButtonClicked: any,
}

class LiveStreamModal extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.closeModal();
  }

  render() {
    let {
      isVisible,
      title,
      buttonType,
      modalButtonClicked
    } = this.props;
    let skylightWrapperClass = classNames({
      "hidden": !isVisible
    });
    return (
      <div className={skylightWrapperClass}>
        <DefaultSkyLightStateless
          isVisible={isVisible}
          onCloseClicked={this.closeModal}
          onOverlayClicked={this.closeModal}
          className="modal-dialog br8"
          title={<div className="px2 pt2">
                  <div className="flexbox-wrapper flexbox-space-between">
                    <div className="flexbox-item-small live-stream-modal-title-fixed-box cs-bg-light-gray border-circle flexbox-center mr2 cs-clickable" onClick={modalButtonClicked}>
                      <i className={`fa ${getModalActionButton(buttonType)} cs-dark-gray-alt`} />
                    </div>
                    <div className="flexbox-center">
                      <span className="mb-dark-blue fs-xl fw-b">
                        {title}
                      </span>
                    </div>
                    <div className="flexbox-item-small live-stream-modal-title-fixed-box"></div>
                  </div>
                  <hr className="m0 mt2 mxn2"/>
                </div>
                }
        >
          {isVisible &&
            this.props.children
          }
        </DefaultSkyLightStateless>
      </div>
    )
  }

}

export default LiveStreamModal;